import antdEnUS from 'antd/es/locale/en_US';
import en from './locales/en_US.json'
import th from './locales/th.json'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { THEME_CONFIG } from 'configs/AppConfig';

const usDateLocale = {
    ...antdEnUS,
    DatePicker: {
        ...antdEnUS.DatePicker,
        lang: {
            ...antdEnUS.DatePicker?.lang,
            dateFormat: 'MM/DD/YYYY',
            dateTimeFormat: 'MM/DD/YYYY HH:mm',
        },
    },
    Calendar: {
        ...antdEnUS.Calendar,
        lang: {
            ...antdEnUS.Calendar?.lang,
            dateFormat: 'MM/DD/YYYY',
            dateTimeFormat: 'MM/DD/YYYY HH:mm',
        },
    },
};

export const resources = {
    en: {
        translation: en,
        antd: usDateLocale
    },
    th: {
        translation: th,
        antd: usDateLocale
    },
}

i18n.use(initReactI18next).init({
    resources,
    fallbackLng: THEME_CONFIG.locale,
    lng: THEME_CONFIG.locale,
    interpolation: {
        escapeValue: false 
    }
})

export default i18n;